import './style/index.css';
import { App } from './components/app';

// default export is required preactjs to work
export default App;
